import $ from 'jquery';
import DialogPopover from '@/interfaces/dialog_popover';

    function add_popover(options) {
        var $target = $(options.target);
        $target.append('<span class="popover-target"></span>');

        options.el = $target.find('.popover-target');

        var PopOver = new DialogPopover(options);
        PopOver.render();
    }   
    export default add_popover;

